import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

const ExampleImagesPopup = ({
  images
}) => {

  const { t } = useTranslation("myGarage");

  return (
    <Box>
      <Typography>
        {t("Example Images")}
      </Typography>

      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "0.15rem"
        }}
      >
        {images?.map?.((image, imageIdx) => {
          return (
            <img 
              key={imageIdx}
              src={image || ""}
              alt={`Example-img-${imageIdx}`}
              style={{
                height: "10rem",
                objectFit: "cover"
              }}
            />
          );
        })}
      </Box>
    </Box>
  );
};

export default ExampleImagesPopup;